export default function flattenPaginatedData(data) {
  return data?.pages?.map((page) => page?.data).flat();
}
